import { useMutation, useQuery, useInfiniteQuery } from "@tanstack/react-query";
import axiosInstance from "../../api/axiosInstance";
import { toast } from "react-toast";

const FALLBACK_PROVIDERS = [
  { id: 1, provider: 'OpenAI' },
  { id: 2, provider: 'Anthropic' },
  { id: 3, provider: 'Mistral' },
  { id: 4, provider: 'Cohere' }
];

export const useSelfHeal = () => {
  return useMutation({
    mutationFn: async (payload) => {
      console.log('self heal payload -->', payload)
      const response = await axiosInstance.post(
        "/self_healing/toggle_self_healing",
        payload
      );
      return response;
    },
  });
};

export const useHealedProjects = () => {
  return useQuery({
    queryKey: ['healed-projects'],
    queryFn: async () => {
      const response = await axiosInstance.get('/self_healing/self_healing_status');
      return response;
    }
  });
};


export const useProjects = () => {
  return useQuery({
    queryKey: ['projects'],
    queryFn: async () => {
      const response = await axiosInstance.get(
        '/projects/list_project?page=1&page_size=100&sort_type=2&sort_order=2'
      );
      return response?.projects || [];
    },
    staleTime: 5 * 60 * 1000,
    retry: 2,
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        error?.message ||
        'Failed to load projects';
      toast.error(message);
    },
  });
};

export const useInfiniteProjects = ({
  search = '',
  pageSize = 20,
  enabled = true,
} = {}) => {
  return useInfiniteQuery({
    queryKey: ['projects-infinite', search, pageSize],
    queryFn: async ({ pageParam = 1 }) => {
      const params = {
        page: pageParam,
        page_size: pageSize,
        sort_type: 2,
        sort_order: 2,
      };

      if (search && search.trim() !== '') {
        params.search = search.trim();
      }

      const response = await axiosInstance.get('/projects/list_project', {
        params,
        skipGlobalLoader: true,
      });

      return {
        projects: response?.projects || [],
        total_pages: response?.total_pages || 1,
        page: pageParam,
      };
    },
    getNextPageParam: (lastPage) => {
      if (lastPage.page < lastPage.total_pages) {
        return lastPage.page + 1;
      }
      return undefined;
    },
    initialPageParam: 1,
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: 2,
  });
};


export const useAiProviders = () => {   
  return useQuery({
    queryKey: ['aiProviders'],          
    queryFn: async () => {
      try {
        const response = await axiosInstance.get('/ai_tools/ai_provider_dropdown');
        return response?.data || FALLBACK_PROVIDERS;
      } catch (error) {
        const message = error?.response?.data?.message || 'Failed to load AI providers';
        toast.error(message);
        return FALLBACK_PROVIDERS;     
      }
    },
    staleTime: 5 * 60 * 1000,
    retry: 2,
  });
};


export const useLatestAgentVersion = ({ osId, agentType }) => {
  return useQuery({
    queryKey: ['latest-agent-version', osId, agentType],
    queryFn: async () => {
      try {
        const response = await axiosInstance.get(`/crawler/latest_agent`,
          {
            params: {
              agent_type: agentType,
              os: osId,
            },
          }
        );
        return response;
      } catch (error) {
        const message =  error?.response?.data?.message ||'Failed to fetch latest agent version';
        toast.error(message);
        return null;
      }
    },
  });
};

